// kept only for reference
// const unit = 2;
// const ico8 = unit * 4 + 'px'; // xsmall
// const ico10 = unit * 5 + 'px'; // small
// const ico12 = unit * 6 + 'px'; // regular
// const ico18 = unit * 9 + 'px'; // large

export const defaultFontThemeProperties = {
  fontFamily: `'Lato', sans-serif`,
  unit: 1.2,
  unitScale: 1,
  unitScaleStartingPoint: 0.2,
};

export default function buildFont(fontThemeProperties = defaultFontThemeProperties) {
  return {
    fontFamily: fontThemeProperties.fontFamily,
    small: {
      font8: fontThemeProperties.unit - fontThemeProperties.unitScaleStartingPoint * 2 + 'rem', //8px | 0.8rem
      font10: fontThemeProperties.unit - fontThemeProperties.unitScaleStartingPoint + 'rem', //10px | 1rem
      font11: fontThemeProperties.unit - 0.1 +'rem', //11px | 1.1rem
    },
    base: fontThemeProperties.unit + 'rem', // 12px | 1.2rem
    large: {
      font13: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint - 0.1 + 'rem', // 13px | 1.3rem
      font14: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint + 'rem', // 14px | 1.4rem
      font15: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint + 0.1 + 'rem', // 15px | 1.5rem
      font16: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 2 + 'rem', // 16px | 1.6rem
      font17: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 2 + 0.1 + 'rem', // 17px | 1.7rem
      font18: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 3 + 'rem', // 18px | 1.8rem
      font20: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 4 + 'rem', // 20px | 2rem
      font21: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 4 + 0.1 + 'rem', //21px | 2.1rem
      font22: fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 6 +  'rem', //22px | 2.2rem
      font24: fontThemeProperties.unit + fontThemeProperties.unit + 'rem', // 24px | 2.4rem
      font25: fontThemeProperties.unit + fontThemeProperties.unit + 0.1 + 'rem', // 25px | 2.5rem
      font26: fontThemeProperties.unit + fontThemeProperties.unit + 0.2 + 'rem', // 26px | 2.6rem
      font28: fontThemeProperties.unit + fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 2 + 'rem', // 28px | 2.8rem
      font30: fontThemeProperties.unit + fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 3 + 'rem', // 30px | 3rem
      font35: fontThemeProperties.unit + fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 5 + 0.1 + 'rem', // 35px | 3.5rem
      font40: fontThemeProperties.unit + fontThemeProperties.unit + fontThemeProperties.unitScaleStartingPoint * 8 + 'rem', // 40px | 4rem
    },
    lineHeight: {
      small: 1.2,
      base: 1.33,
      large: 1.5,
    },
    letterSpacing: {
      small: '-0.018rem',
      base: '-0.02rem',
      large: '-0.04rem'
    },
    textAlign: {
      left: 'left',
      center: 'center',
      right: 'right'
    },
    fontWeight: {
      black: '900',
      semiBold: '600',
      bold: 'bold',
      medium: '500',
      normal: 'normal'
    },
    textTransform: {
      upper: 'uppercase',
      none: 'none',
      capital: 'capitalize'
    }
  };
}
